<app-payment-gate-status [PG_CODE]="transferId" [paymentStatus]="paymentStatus" [waitUntilSuccess]="true"></app-payment-gate-status>